module.exports = __webpack_public_path__ + "static/media/vylet.03d0cc74.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/vylet.png
// module id = 693
// module chunks = 0